import React from "react";
import ArisCoach from "../../Coach";
import "../styles.css";

/**
 * @param {boolean} autoStart Open the voice session on mount, so choosing
 *   "Voice" on the Aris tab is a single tap. Off by default, which is what the
 *   /coach routes want — they show the session's own Start control.
 */
const CoachPrivateV2 = ({ autoStart = false }) => {
  // Walkthrough is implemented inside ArisCoach now.
  return (
    <div className="coachv2-wrap">
      <ArisCoach autoStart={autoStart} />
    </div>
  );
};

export default CoachPrivateV2;
